import { render, staticRenderFns } from "./_tabSportsmans.vue?vue&type=template&id=2ff83bd5&scoped=true&"
import script from "./_tabSportsmans.vue?vue&type=script&lang=js&"
export * from "./_tabSportsmans.vue?vue&type=script&lang=js&"
import style0 from "./_tabSportsmans.vue?vue&type=style&index=0&id=2ff83bd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff83bd5",
  null
  
)

export default component.exports